module.exports = __webpack_public_path__ + "img/5d31f4e9e9d2b797d73ae35b0119e6b8.svg";